"use client";

import { useRouter } from "next/navigation";

const Border = () => {
	return (
		<div
			className={
				"h-4 border-b-2 border-suzuka2024naby w-12 md:border-b-3 md:w-32"
			}
		/>
	);
};
export const Top = () => {
	const router = useRouter();
	return (
		<div className={"flex flex-col gap-4"}>
			<h1
				className={
					"text-suzuka2024naby font-bold text-center text-[24px] md:text-4xl"
				}
			>
				<span className={"whitespace-nowrap"}>高専ビジネスコンテスト</span>
				<span className={"whitespace-nowrap"}>in 鈴鹿高専2024</span>
			</h1>
			<div className={"flex justify-center gap-2"}>
				<Border />
				<h2
					className={
						"text-suzuka2024naby text-lg font-bold whitespace-nowrap md:text-2xl"
					}
				>
					夢を紡ぎ新しい未来へ
				</h2>
				<Border />
			</div>
			<p className={"text-suzuka2024 font-bold text-sm md:text-lg"}>
				　近年、日本のみならず多くの先進国で労働力に関する問題が発生しています。日本でも、副業人材や外国籍人材の活用の取り組みが行われています。
				企業では、あらゆる職種で効率化を目的としたサービスが展開されています。
				<br />
				　そこで、今回は労働力不足を解決できる新しいビジネスを創造していきます。
			</p>
			<button
				type="button"
				className={
					"bg-[#ff5757] text-white py-4 px-20 w-fit rounded-full mx-auto text-2xl"
				}
				onClick={(): void => {
					router.push("#apply");
				}}
			>
				応募する
			</button>
		</div>
	);
};
